import type { WaterProfile } from "../types";
import { PROFILES, PRODUCT_IMAGE, PRODUCT_LINE } from "../profiles";
import { assetUrl } from "../assets";

export function ProductCard({ profileKey }: { profileKey: WaterProfile }) {
  return (
    <div className="product reveal">
      <span className="pchip">El producto</span>
      <img className="phero" src={assetUrl(PRODUCT_IMAGE)} alt="Cabezal de ducha AURAL" />
      <h3>{PRODUCT_LINE}</h3>
      <p className="pinside">
        <b>Lleva:</b> {PROFILES[profileKey].inside}
      </p>
    </div>
  );
}
